import { render } from "./ManagementDistributionCard.vue?vue&type=template&id=2c83b0f6&scoped=true"
import script from "./ManagementDistributionCard.vue?vue&type=script&lang=js"
export * from "./ManagementDistributionCard.vue?vue&type=script&lang=js"

import "./ManagementDistributionCard.vue?vue&type=style&index=0&id=2c83b0f6&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c83b0f6"]])

export default __exports__